export default __webpack_public_path__ + "static/Rock_Drake_Tek_Saddle-3624883c9ee4b8a57a1771cb83283d50.png";